import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  GlgCheckbox,
} from 'SharedComponents'
import { Modal, Button } from 'react-bootstrap'
import Cropper from 'react-easy-crop'
import styled from 'styled-components'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { getAuthenticityToken } from '../../../shared/helpers'
import { GlgLoadingSpinner } from 'SharedComponents'
import { callAPI } from 'Shared/helpers'
import Loader from 'react-loader-spinner'

const StyledPage = styled.div`
  .name-input {
    width: 400px;
  }
`

const StyledModal = styled(Modal)`
  .modal-body {
    height: 670px;
  }

  .modal-dialog {
    width: 60%;
  }
  
  .crop-container {
    position: relative;
    height: 500px;
  }

`

const DraggableItem = styled.div`
  
  .container {
    display: inline-block;
    width: calc(100% - 51px);
    max-width: 25em;
    padding: 5px;
    height: 15em;
    text-align: center;
    white-space: nowrap;
  }
  .container img {
    display: inline-block;
    width: auto; height: auto;
    max-width: 100%; max-height: 100%;
    vertical-align: middle;
  }
  .container canvas {
    display: inline-block;
    width: auto; height: auto;
    max-width: 100%; max-height: 100%;
    vertical-align: middle;
  }
  .container:after {
    display: inline-block;
    height: 100%; width: 0;
    vertical-align: middle;
    content: "";
  }

  i {
    cursor: pointer;
    margin-left: -31px;
  }
`

const CroppedImg = ({img, newWidth, newHeight, startX, startY}) => {
  // Set up canvas for thumbnail
  const canvasRef = useRef(null)
  const imgObj = new Image()
  imgObj.src = img

  useEffect(() => {
    
    const canvas = canvasRef.current
    const context = canvas.getContext('2d')

    context.drawImage(
      imgObj,
      startX, startY, newWidth, newHeight,
      0, 50, 300, 60
    )
  }, [ imgObj ])

  return <canvas ref={canvasRef}/>

}

const BannersNew = (props) => {
  const [ modalOpen, setModalOpen ] = useState(false)
  const [ images, setImages ] = useState(props.data?.photos || [])
  const [ formData, setFormData ] = useState(props.data || {primary: false})
  const [ deleted, setDeleted ] = useState([])
  const [ saveDisabled, setDisabled ] = useState(false)
  const [ isLoading, setIsLoading ] = useState(false)
  const [ defaultBanner, setDefaultBanner ] = useState(props.data?.primary || false)

  useEffect(() => {
    callAPI('/api/customers/' + props.customerId + '/course_albums/', 'GET')
      .then((json) => {
        let defaultBannerPresent = false
        json.forEach(i => {
          defaultBannerPresent ||= i.primary
        })

        if (!props.data?.id && !props.data?.primary && (json.length === 0 || !defaultBannerPresent)) {
          setDefaultBanner('true')
          handleFormData('true', 'primary')
        }
      })
  }, [])

  const saveAlbum = (update) => {
    setIsLoading(true)
    if (saveDisabled) {
      return
    }

    setDisabled(true)

    const fd = new FormData()
    
    fd.append('name', formData.name)
    fd.append('primary', formData.primary)

    images.forEach(i => {
      fd.append('crop[]', JSON.stringify(i.crop || ''))
      fd.append('photos[]', i.imageFile || i.filename)
    })

    deleted.forEach(d => {
      fd.append('deleted[]', d || '')
    })

    if (update) {
      fetch('/api/customers/' + props.customerId + '/course_albums/' + props.data.id, {
        method: 'PATCH',
        body: fd,
        headers: {'X-CSRF-Token': getAuthenticityToken()}})
      .then(() => { 
        setDisabled(true)
        setIsLoading(false)
        props.setPage('index')
      })
      // eslint-disable-next-line no-console
      .catch((e) => console.log(e))
    } else {
      fetch('/api/customers/' + props.customerId + '/course_albums', {
        method: 'POST',
        body: fd,
        headers: {'X-CSRF-Token': getAuthenticityToken()}})
      .then(() => { 
        setDisabled(true)
        setIsLoading(false)
        props.setPage('index')
      })
      // eslint-disable-next-line no-console
      .catch((e) => console.log(e))
    } 
    
  }

  const handleFormData = (e, key) => {
    const value = typeof(e) === 'object' ? e.target.value : e
    setFormData({...formData, [key]: value})
  }

  return (
    <StyledPage>
      {isLoading && 
        <div>
          <GlgLoadingSpinner 
          show={isLoading}
          className='add-margin-top-20 text-center'
          />
          <div className='save_bar'>
            <a className='button btsp_gray_button disabled'>Cancel</a>
            <a className='button btsp_orange_button disabled'>{props.data?.name ? 'Update' : 'Save'}</a>
          </div>
        </div>
        }
      {!isLoading &&
        <div>
          <div className='btsp_form_content col-xs-12'>
            <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 tabs_content btsp_form_content">
              <ul className='btsp_ul'>
                <li className='form_row'>
                  <div className='row'>
                    <div className='col-sm-3 col-md-3 col-lg-3 hidden-xs'>
                      <label>Name</label>
                    </div>
                    <div className='col-xs-12 col-sm-9 col-md-9 col-lg-9'>
                      <input defaultValue={props.data?.name} onChange={(e) => handleFormData(e, 'name')} type='text' className='form-control form-text name-input'/>
                    </div>
                  </div>
                </li>
                <li className='form_row'>
                  <div className='row'>
                    <div className='col-sm-3 col-md-3 col-lg-3 hidden-xs'>
                      <label>Default</label>
                    </div>
                    <div className='col-xs-12 col-sm-9 col-md-9 col-lg-9'>
                      <GlgCheckbox 
                        name="primary"
                        value="true"                        
                        checked={ defaultBanner }
                        label="Mark this Banner as default"
                        defaultChecked={ props.data?.primary }
                        onChange={ (e) => handleFormData(e, 'primary') }/>
                    </div>
                  </div>
                </li>
                <li className='form_row'>
                  <div className='row'>
                    <div className='col-sm-3 col-md-3 col-lg-3 hidden-xs'>
                      <label>Banners</label>
                    </div>
                    <div className='col-xs-12 col-sm-9 col-md-9 col-lg-9'>
                      <BannerItems
                        images={images}
                        setImages={setImages}
                        deleted={deleted}
                        setDeleted={setDeleted}
                        setModalOpen={setModalOpen}
                      />
                    </div>

                  </div>
                </li>
              </ul>
            </div>
          </div>
          <AddPhotoPopup
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            images={images}
            setImages={setImages}
          />
          <div className='save_bar'>
            <a className='button btsp_gray_button' onClick={() => props.setPage('index')}>Cancel</a>
            <a className='button btsp_orange_button' onClick={() => saveAlbum(props.data?.name ? 'update' : undefined)}>{props.data?.name ? 'Update' : 'Save'}</a>
          </div>
        </div>}
    </StyledPage>
  )
}

export const AddPhotoPopup = (props) => {
  const [ imagePreview, setImagePreview ] = useState({ image: '', crop: ''})
  const [ disableImageSave, sedDisableImageSave ] = useState(true)
  const [ crop, setCrop ] = useState({ x: 0, y: 0 })
  const [ zoom, setZoom ] = useState(1)
  
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    if (imagePreview.image) {
      setImagePreview({image: imagePreview.image, imageFile: imagePreview.imageFile, crop: croppedAreaPixels})
    }
  }, [ imagePreview.image ])

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    setImagePreview({image: URL.createObjectURL(file), imageFile: file, crop: ''})

    let message = ''
    if (file.size > 6000000) { // bytes
      message = 'File exceeds maximum size.'
    }
    
    if ([ 'image/jpeg', 'image/png', 'image/gif', 'image/bmp' ].indexOf(file.type) < 0) {
      message += ' File format should be jpg, jpeg, gif, png, bmp.'
    }

    if (message !== '') {
      $('.error-message').removeClass('hidden')
      $('.error-message').html(message)
      sedDisableImageSave(true)

    } else {
      $('.error-message').addClass('hidden').disabled = false
      sedDisableImageSave(false)
    }
  }

  const handleModalClose = () => {
    props.setModalOpen(false)
    setImagePreview({ image: '', crop: ''})
  }

  const saveImage = () => {
    props.setImages([ ...props.images, imagePreview ])
    handleModalClose()
  }

  return (
    <StyledModal show={props.modalOpen} onHide={() => handleModalClose()}>
      <Modal.Header closeButton>
        Add Banner Photo
      </Modal.Header>
      <Modal.Body>
        <input className='add-margin-bottom-10' type='file' accept='image/jpeg, image/png, image/gif, image/bmp' onChange={(e) => handleImageUpload(e)}/>
        <div className='help-message add-margin-bottom-10'>
          <div>{window.I18n.t('views.golfhub.accepted_photo_formats')}</div>
          <div>{window.I18n.t('views.golfhub.banner_acceptable_format')}</div>
        </div>
        <div className='error-message btsp_alert_notices hidden add-margin-bottom-10 add-padding-all-5'></div>
        <div className='crop-container'>
          <Cropper
            image={imagePreview.image}
            crop={crop}
            zoom={zoom}
            aspect={6 / 1.25}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => handleModalClose()}>Close</Button>
        <Button className='add-margin-left-10 button btsp_orange_button' disabled={!imagePreview.image || disableImageSave} onClick={() => saveImage()} >Save</Button>
      </Modal.Footer>
    </StyledModal>
  )
}

export const BannerItems = ({images, setImages, deleted, setDeleted, setModalOpen, showLoading}) => {
  const swapImages = (result) => {
    const tempArr = [ ...images ]
    const tempVar = tempArr[ result.source.index ]
    tempArr.splice(result.source.index, 1)
    tempArr.splice(result.destination.index, 0, tempVar)

    setImages(tempArr)
  }

  const removeImage = (index) => {
    const tempArr = [ ...images ]
    setDeleted([ ...deleted, tempArr.splice(index, 1)[0]?.id ])
    setImages(tempArr)
  }

  return (
    <Fragment>
      <div className='add-margin-bottom-20 btsp_bullet_button pointer' onClick={() => setModalOpen(true)}>
        <div className='icon'><i className='gga-circle-plus'></i></div>
        <div className='btsp_align-middle'>Add Banner</div>
      </div>
      {images.length > 0 && (
        <DragDropContext onDragEnd={swapImages}>
          <Droppable droppableId="droppable">
          {(provided) => (
            <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className='img-container'>
              
              {images.map((img, i) => (
                <Draggable key={'draggable-' + i} draggableId={'draggable-' + i} index={i} >
                  {(prov) => (
                    <DraggableItem
                      ref={prov.innerRef}
                      {...prov.draggableProps}
                      {...prov.dragHandleProps}>
                      <i className='fa fa-bars fa-lg add-margin-right-5'></i>
                      <div className='container'>{img.crop ? (<CroppedImg img={img.image} newWidth={img.crop.width} newHeight={img.crop.height} startX={img.crop.x} startY={img.crop.y} />) : (<img src={img.image}/>) }</div>
                      {showLoading === true && (
                        <span className="span pull-right glg-loading-spinner banner-loading">
                          <Loader type="Oval" color={ '#0088CE' } height={ 20 } width={ 30 }></Loader>
                        </span>
                      )}
                      <i className='fa fa-trash fa-lg add-margin-left-5' onClick={() => removeImage(i)}></i>
                    </DraggableItem>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
          </Droppable>
        </DragDropContext>
      )}
    </Fragment>
  )
}

AddPhotoPopup.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  images: PropTypes.array,
  setImages: PropTypes.func,
}

BannersNew.propTypes = {
  setPage: PropTypes.func,
  customerId: PropTypes.string,
  data: PropTypes.object,
}

BannerItems.propTypes = {
  setModalOpen: PropTypes.func,
  setImages: PropTypes.func,
  setDeleted: PropTypes.func,
  images: PropTypes.array,
  deleted: PropTypes.array,
  showLoading: PropTypes.bool,
}

CroppedImg.propTypes = {
  img: PropTypes.string,
  newWidth: PropTypes.number,
  newHeight: PropTypes.number,
  startX: PropTypes.number,
  startY: PropTypes.number,
}
export default BannersNew
